import { Line } from "./line";
import { Measure } from './measure';

export class PK {
  id: number = null;
  bayLength: number = null;
  geographicLocation: string = null;
  line: Line = new Line();
  measures: Measure[] = [];
  nonexistent: boolean = false;
  number: number | string = null;
  potential: string = null;
  steel: string = null;
  trackAlignment: string = null;
  way: string = null;

  constructor() {
  }

  public convertStringsToNumbers(): PK {
    this.number = Number(this.number);
    return this;
  }

  getNextMultipleOf5(): number {
    return (Number(this.number) + 5 - (Number(this.number) % 5));
  }

  getPreviousMultipleOf5(): number {
    return (Number(this.number) - 5)%5 == 0 ? (Number(this.number) - 5) : ((Number(this.number) - 5) + (5-Number(this.number) % 5));
  }

  hasComplementaryMeasures() {
    let latestMeasure: Measure = this.measures[0];
    if(latestMeasure) {
      return !!(latestMeasure.centralPart && latestMeasure.height && latestMeasure.length && latestMeasure.wing2);
    }
    return false;
  }

  hasCompleteLocation():boolean {
    return !!(this.line.id && this.line.name && this.number && this.potential && this.way);
  }

  setId(id: number): PK {
    this.id = id;
    return this;
  }

  setGeographicLocation(geographicLocation: string): PK {
    this.geographicLocation = geographicLocation;
    return this;
  }

  setLine(line: Line): PK {
    this.line = line;
    return this;
  }

  setMeasures(measures: Measure[]): PK {
    this.measures = measures;
    return this;
  }

  setNonexistent(nonexistent: boolean): PK {
    this.nonexistent = nonexistent;
    return this;
  }

  setNumber(number: number): PK {
    this.number = number;
    return this;
  }

  setPotential(potential: string): PK {
    this.potential = potential;
    return this;
  }

  setSteel(steel: string): PK {
    this.steel = steel;
    return this;
  }

  setTrackAlignment(trackAlignment: string): PK {
    this.trackAlignment = trackAlignment;
    return this;
  }

  setWay(way: string): PK {
    this.way = way;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/pk.ts